import React from 'react';
import HomeLogin from '../components/HomeLogin'
import reactRender from '../../../common/js/lib/react-render';


reactRender('#home-banner-login-container', <HomeLogin />)
